//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'SitemapList',
  components: {
    MdmLink
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};